import styled from 'styled-components'
import { Avatar as AntAvatar } from 'antd'
import { COLORS, SPACING, SHADOWS, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for ProfileHeader
 */

export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.sm};
  margin-bottom: ${SPACING.xl};
`

export const ProfileAvatar = styled(AntAvatar)<{ $avatarSize?: number }>`
  &.ant-avatar {
    background: linear-gradient(135deg, ${COLORS.primary} 0%, #4096ff 100%);
    font-size: ${(props) => (props.$avatarSize ? Math.round(props.$avatarSize * 0.38) : 36)}px;
    font-weight: ${FONT_WEIGHT.medium};
    box-shadow: ${SHADOWS.md};
    border: 3px solid var(--color-bg-elevated);
  }
`

export const UserName = styled.h4`
  margin: ${SPACING.xs} 0 0 0;
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  text-align: center;
`
